import * as _4 from 'lodash4';
import { IMyScheduleNativeCalenderFunction } from '../functions/my_schedule_native_calendar_fn';
import { Schedule } from './../builders/schedule_builder';
import { ICalendarEvent, ICalendarLocalDatabase } from './../types/my_schedule_types';

angular
  .module('capability-ng-course-schedule')
  .factory(
    'addCourseToCalendarCommand',
    function addCourseToCalendarCommandDefinition(
      defineCommand: any,
      myScheduleNativeCalendarFn: IMyScheduleNativeCalenderFunction,
      ngCalendarLocalDatabase: ICalendarLocalDatabase
    ) {
      return defineCommand(
        'addCourseToCalendarCommand',
        async function addCourseToCalendarCommand(deferred: any, courses: Schedule) {
          const calendarObjects: ICalendarEvent[] = myScheduleNativeCalendarFn.createCourseCalendarObjects(
            _4.toArray(courses)
          );
          const syncedCourseEvents: ICalendarEvent[] = await ngCalendarLocalDatabase.getAllSyncedCourses(
            calendarObjects
          );

          myScheduleNativeCalendarFn
            .deleteAllCoursesFromCalendar(syncedCourseEvents)
            .then(() => {
              return myScheduleNativeCalendarFn.addAllCoursesToCalendar(calendarObjects);
            })
            .catch((err: any) => deferred.reject(err));
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/commands/add_courses_to_calendar_command.ts